import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagedResponse } from 'mbs-ui-shared@models';
import { AppsUser, DomainInfo, DomainPayload, DomainsQueryParams, UpdateDomainPayload } from 'mbs-ui-shared@models/domain.model';
import { Observable, of } from 'rxjs';
import { catchError, filter, first } from 'rxjs/operators';
import saveAs from 'file-saver';

@Injectable({ providedIn: 'root' })
export class DomainsService {
  private cacheRestrictedNames: string[];
  private readonly controllerPath = '/api/apps/domains';

  constructor(private http: HttpClient) {}

  public get(params?: DomainsQueryParams): Observable<PagedResponse<DomainInfo>> {
    return this.http.get<PagedResponse<DomainInfo>>(this.controllerPath, { params });
  }

  public getById(id: string): Observable<DomainInfo> {
    return this.http.get<DomainInfo>(`${this.controllerPath}/${id}`);
  }

  public getByName(name: string): Observable<DomainInfo> {
    return this.http.get<DomainInfo>(`${this.controllerPath}/name/${name}/`);
  }

  public create(payload: DomainPayload[]): Observable<DomainInfo> {
    return this.http.post<DomainInfo>(this.controllerPath, payload);
  }

  public update(payload: UpdateDomainPayload): Observable<DomainInfo> {
    return this.http.put<DomainInfo>(this.controllerPath, payload);
  }

  public deleteDomains(ids: string[]): Observable<any> {
    return this.http.delete(this.controllerPath, { body: { domains: ids } });
  }

  public getAvailableDomainNames(payload: string[]): Observable<string[]> {
    return this.http.post<string[]>(`${this.controllerPath}/available`, payload);
  }

  public getDomainStatistic(): Observable<PagedResponse<AppsUser>> {
    return this.http.get<PagedResponse<AppsUser>>(`${this.controllerPath}/totals`);
  }

  public getRestrictedNames(): Observable<string[]> {
    return this.http.get<string[]>(`${this.controllerPath}/restricted-names`);
  }

  public exportTo(type: 'html' | 'csv'): void {
    window.open(`${this.controllerPath}/export?reportFormat=${type}`, '_blank');
  }

  /*
  public checkAllAccessAppsUsers(): boolean {
    return (
      this.ability.can('read', 'Provider') ||
      (this.ability.can('read', 'SubAdmin') &&
        this.ability.can('read', PermissionsEnum.GoogleApps) &&
        this.ability.can('read', PermissionsEnum.AccessToAllCompanies))
    );
  }
*/
}
